module.exports = __webpack_public_path__ + "img/logo_font2@2x.3762935f.png";